import { Sparkles } from "lucide-react";

import { canSwitchToNewUI, setNewUI } from "../../v2/flag";
import "./NewUIButton.less";

/** The way into the new UI from the classic header; lands on the project's Overview, or the project list */
export default function NewUIButton({ projectId }: { projectId?: string }) {
    if (!canSwitchToNewUI(projectId)) return null;
    return (
        <button
            type="button"
            className="new-ui-button"
            onClick={() => setNewUI(true, projectId ? `/projects/${projectId}/overview` : "/projects")}
            title="Open the redesigned Microtica. You can switch back any time from the account menu."
        >
            <Sparkles size={14} className="new-ui-button-icon" />
            <span>Try the new Microtica</span>
            <span className="new-ui-button-tag">New</span>
        </button>
    );
}
